module.exports = __webpack_public_path__ + "img/06.13b6e73b.png";